import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IChangeTrackerTrafficSourcePayload } from '../types';
import {
  AFFILIATE_CHANGE_TRACKER_TRAFFIC_SOURCE_API_URL,
  AFFILIATE_CHANGE_TRACKER_TRAFFIC_SOURCE_MUTATION,
  AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS,
} from '../constants';

export default function useChangeTrackerTrafficSourceMutation(): IContextMutationResult<void, Error, IChangeTrackerTrafficSourcePayload> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IChangeTrackerTrafficSourcePayload>({
    mutationKey: [AFFILIATE_CHANGE_TRACKER_TRAFFIC_SOURCE_MUTATION],
    mutationFn: ({ affId, trackerId, ...payload }) => fetchPut<void>(
      AFFILIATE_CHANGE_TRACKER_TRAFFIC_SOURCE_API_URL,
      payload,
      {
        permission: AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS.CHANGE_TRAFFIC_SOURCE,
        urlParams: {
          id: affId,
          trackerId,
        },
      },
    ),
    onSuccess() {
      displayPresetToast('edited');
    },
  });
}
